import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IPublishProductsRequestBody, IPublishProductsResponse } from './types';

export const publishProducts = async ({
  price_scheme_id = undefined,
  ...payload
}: IPublishProductsRequestBody): Promise<IPublishProductsResponse> => {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (price_scheme_id) {
    headers[PRICE_SCHEME_HEADER] = price_scheme_id;
  }
  const url = `${API_URL}/publish/products`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers,
  });

  const json = await res.json();

  if (!res.ok) {
    throw new Error(json?.message ?? 'Something went wrong whilst publishing products');
  }

  return json;
};
